exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.description[data-v-1f848a3a] {\n    padding: 5px 10px;\n}\n", ""]);

